import React, { useState, useMemo } from 'react'
import { Checkbox, H5, Pagination, PaginationType } from '@raysync/common/components'
import { Navigation } from '@raysync/common/services'
import Layout from '../../components/layout'
import { Banner, ContentWrap, FilterBar, PostContainer, PostItem, PaginationWrapper } from './atoms'
import { SearchService, primaryTitleMap, useDocumentsQuery } from '../../service'
import { EmptyContent, SearchInput } from '../../components'
const PAGE_SIZE = 8
const SearchPage = ({ location }) => {
  const allData = useDocumentsQuery()
  const [params, setParams] = React.useState({
    product: true,
    whitePaper: true,
    video: true,
    faq: true,
    pageNum: 1,
  })
  const [categoryCount, setCategoryCount] = React.useState({
    product: 0,
    whitePaper: 0,
    video: 0,
    faq: 0,
  })
  const [inputValue, setInputValue] = useState('')
  const [results, setResults] = useState([])
  const handleSearch = (keyword = inputValue) => {
    let counts = {
      product: 0,
      whitePaper: 0,
      video: 0,
    }
    let res = []
    if (keyword) {
      res = SearchService.search(keyword)
      res.forEach(post => {
        counts[post.type] += 1
      })
    }
    setCategoryCount(counts)
    setResults(res)
  }
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      const keyword = params.get('keyword')
      if (keyword && allData.length > 0) {
        setInputValue(keyword)
        handleSearch(keyword)
      }
    }
  }, [allData.length])
  const filteredResults = useMemo(() => {
    const trueKeys = Object.keys(params).filter(key => params[key])
    return results.filter(post => trueKeys.includes(post.type))
  }, [results, params])
  const pagainedResults = filteredResults.slice((params.pageNum - 1) * PAGE_SIZE, params.pageNum * PAGE_SIZE)
  let numPages = Math.ceil(filteredResults.length / PAGE_SIZE) || 1

  return (
    <Layout pageType='support' location={location}>
      <Banner>
        <SearchInput value={inputValue} handleSearch={handleSearch} />
        <p>为您找到相关结果约{results.length}条</p>
      </Banner>
      <ContentWrap>
        <FilterBar>
          <H5>资源</H5>
          <div>
            <Checkbox
              checked={params.product}
              onChange={checked => {
                setParams({ ...params, product: checked, pageNum: 1 })
              }}
            >
              操作指南({categoryCount.product})
            </Checkbox>
            <Checkbox
              checked={params.whitePaper}
              onChange={checked => {
                setParams({ ...params, whitePaper: checked, pageNum: 1 })
              }}
            >
              白皮书({categoryCount.whitePaper})
            </Checkbox>
            <Checkbox
              checked={params.video}
              onChange={checked => {
                setParams({ ...params, video: checked, pageNum: 1 })
              }}
            >
              演示视频({categoryCount.video})
            </Checkbox>
            {/* <Checkbox
              checked={params.faq}
              onChange={checked => {
                setParams({ ...params, faq: checked, pageNum: 1 })
              }}
            >
              FAQ({categoryCount.faq})
            </Checkbox> */}
          </div>
        </FilterBar>
        <PostContainer>
          {pagainedResults && pagainedResults.length > 0 ? (
            <>
              {pagainedResults.map((post, index) => (
                <PostItem key={index}>
                  <h4
                    dangerouslySetInnerHTML={{ __html: post.highlightTitle }}
                    onClick={() => {
                      Navigation.to({ link: post.url })
                    }}
                  ></h4>
                  <p dangerouslySetInnerHTML={{ __html: post.highlightContent }}></p>
                  <span>{`来自：${primaryTitleMap[post.type]}`}</span>
                </PostItem>
              ))}
              <PaginationWrapper>
                <Pagination
                  onChange={page => {
                    const pageNum = Number(page)
                    setParams({ ...params, pageNum })
                  }}
                  type={PaginationType.Dynamic}
                  currentPage={params.pageNum}
                  total={numPages}
                />
              </PaginationWrapper>
            </>
          ) : (
            <EmptyContent />
          )}
        </PostContainer>
      </ContentWrap>
    </Layout>
  )
}
export default SearchPage
